import katex from 'katex';
import 'katex/dist/katex.min.css';

const html = katex.renderToString('\\boldsymbol{\\partial}', { throwOnError: false });

export default function PixelArtLogo() {
  return (
    <div
      className="ov-logo-symbol relative w-6 h-6 shrink-0 flex items-center justify-center"
      role="img"
      aria-label="OptionView logo — partial derivative symbol"
    >
      <span dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
